import type { IUserInfo } from "@/account/account-models";
import type { IFeedInfo } from "@/feed/feed-models";
import type { IDictionary } from "@/models";
import { createAction } from "@reduxjs/toolkit";
import type { IGetProfilesResponse } from "./discover-api";
import type {
  EDiscoverFilterType,
  IDiscoverFilter,
  IGetProfilesConfig,
} from "./discover-helpers";
import type { EDiscoverPunishmentAlertType } from "./discover-models";

export namespace IDiscoverActions {
  export enum Type {
    FILTER__OPEN = "FILTER__OPEN",

    GET__PROFILES__INIT = "GET__PROFILES__INIT",
    GET__PROFILES__SUCCESS = "GET__PROFILES__SUCCESS",

    SET__DISCOVER_ALERT_CONFIRMED = "SET__DISCOVER_ALERT_CONFIRMED",

    SET__DISCOVER_PROFILE_IMPRESSION_TRACKED = "SET__DISCOVER_PROFILE_IMPRESSION_TRACKED",

    SET__DISCOVER_CARDS_FILTERS = "SET__DISCOVER_CARDS_FILTERS",

    GET__DISCOVER_CARDS__SUCCESS = "GET__DISCOVER_CARDS__SUCCESS",

    // Advances the local card queue (current card -> history). Separate
    // from the "mark as visited" API request (discoverApi), since this
    // part never depends on that request settling either way.
    ADVANCE_DISCOVER_CARD = "ADVANCE_DISCOVER_CARD",

    SET__DISCOVER_CARD_IMPRESSION_TRACKED = "SET__DISCOVER_CARD_IMPRESSION_TRACKED",

    GET__CARD_PROFILE_FEED__SUCCESS = "GET__CARD_PROFILE_FEED__SUCCESS",

    GET__CARD_PROFILE_FEED_NEXT__SUCCESS = "GET__CARD_PROFILE_FEED_NEXT__SUCCESS",
  }

  export const openFilter = createAction<{
    filter: EDiscoverFilterType | null;
  }>(Type.FILTER__OPEN);

  export const initGetProfiles = createAction<{
    config: Pick<
      IGetProfilesConfig,
      "isInitialRequest" | "isForceLoader" | "filtersSet"
    >;
    nextUrl?: string;
  }>(Type.GET__PROFILES__INIT);
  export const successGetProfiles = createAction<{
    config: {
      isInitialRequest: boolean;
      filtersSet: IDictionary<IDiscoverFilter>;
    };
    res: IGetProfilesResponse;
  }>(Type.GET__PROFILES__SUCCESS);
  export const setDiscoverAlertConfirmed = createAction<{
    type: EDiscoverPunishmentAlertType;
  }>(Type.SET__DISCOVER_ALERT_CONFIRMED);

  export const setDiscoverProfileImpressionTracked = createAction<string>(
    Type.SET__DISCOVER_PROFILE_IMPRESSION_TRACKED
  );

  export const setDiscoverCardsFilters = createAction<
    IDictionary<IDiscoverFilter>
  >(Type.SET__DISCOVER_CARDS_FILTERS);

  export const successGetDiscoverCards = createAction<{ data?: IUserInfo[] }>(
    Type.GET__DISCOVER_CARDS__SUCCESS
  );

  export const advanceDiscoverCard = createAction(Type.ADVANCE_DISCOVER_CARD);

  export const setDiscoverCardImpressionTracked = createAction<string>(
    Type.SET__DISCOVER_CARD_IMPRESSION_TRACKED
  );

  export const successGetCardProfileFeed = createAction<{
    userId: string;
    profileFeed: IFeedInfo[];
    nextProfileFeedUrl?: string;
  }>(Type.GET__CARD_PROFILE_FEED__SUCCESS);

  export const successGetCardProfileFeedNext = createAction<{
    userId: string;
    profileFeed: IFeedInfo[];
    nextProfileFeedUrl?: string;
  }>(Type.GET__CARD_PROFILE_FEED_NEXT__SUCCESS);
}

export type DiscoverActions = Omit<typeof IDiscoverActions, "Type">;
